import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CorporateUser, EntityTypes, JobOrder, JobSubmission } from "@bullhorn/bullhorn-types";
import { EntityPickerResult, EntityPickerResults, FormUtils, NovoAsideService, NovoModalRef, NovoModalService, PickerControl, PickerResults, QuickNoteControl, TextAreaControl, TextBoxControl } from "novo-elements";
import { UserSettings } from "src/app/interfaces/bullhorn";
import { AppBridgeService } from "src/app/services/appBridge.service";
import { AppBridgeTargetService } from "src/app/services/appBridgeTarget.service";
import { HttpService } from "src/app/services/http.service";
import { HttpTargetService } from "src/app/services/httpTarget.service";
import { MetaService } from "src/app/services/meta.service";

@Component({
  selector: 'add-target',
  templateUrl: './add-target.component.html',
  styleUrls: ['./add-target.component.scss']
})
export class AddTargetComponent {
  public loading = true;
  public connected = true;
  public textControl: any;
  public candidatePickerControl: any;
  public ownerPickerControl: any;
  public jobOrderPickerControl: any;
  public commentsControl: QuickNoteControl;
  public textForm: any;
  public fieldConfig;
  public dynamic: any;
  public jobOrder: JobOrder | any;
  public submission: JobSubmission | any;
  public fromUser: CorporateUser | any;
  public dynamicForm: any;
  constructor(private appBridgeService: AppBridgeTargetService, private httpService: HttpTargetService, private formUtils: FormUtils, private meta: MetaService, private route: ActivatedRoute) {
    document.documentElement.className = 'custom-menu-item';
    this.formUtils = formUtils;
  }

  ngOnInit() {


    if (this.connected) {
      this.appBridgeService.onRegistered.subscribe(this.onRegistered.bind(this));
      this.appBridgeService.registerCustomMenuItem();
    }

  }
  public close() {
    this.appBridgeService.close();
  }

  public async submitTarget() {
    const createNotePromis = this.httpService.createEntity(EntityTypes.Note, {
      comments: this.textForm.value.comments.note,
      multipleNotes: false,
      personReference: {
        searchEntity: "Candidate",
          id: this.submission?.candidate.id,
          firstName: this.submission?.candidate.firstName,
          lastName: this.submission?.candidate.lastName,
      },
      action: "Target",
      nextAction: "None",
      minutesSpent: 0,
      jobOrders: [
          {
              id: this.jobOrder.id,
          }
      ]
    });

    // make call to backend on current domain
    const createTargetPromise = fetch('https://bh-job-match-8ab81b71eadc.herokuapp.com/sendTargetEmail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        candidate: this.submission?.candidate,
        jobOrder: this.jobOrder,
        fromUser: this.fromUser,
        toUser: this.submission?.candidate.owner,
        comments: this.textForm.value.comments,
      })
    });

    const [createNote, createTarget] = await Promise.all([createNotePromis, createTargetPromise]);
    console.log(createNote, createTarget);
    this.appBridgeService.close();
    console.log(this.textForm.value);
  }

  private async onRegistered(isRegistered, ...args) {
    if (isRegistered) {
      this.loading = false;

      // dataSpecialization: 'HTML-MINIMAL',

      const submissionPromise = this.httpService.getEntity(EntityTypes.JobSubmission, this.route.snapshot.queryParamMap.get('submission') as any, 'candidate(name,id,firstName,lastName,owner(name,id,email))');
      const jobOrderPromise =  this.httpService.getEntity(EntityTypes.JobOrder, this.route.snapshot.queryParamMap.get('job') as any, 'title,id,clientCorporation,owner(name,id,email)');
      const currentUserPromise = this.httpService.getEntity(EntityTypes.CorporateUser, this.route.snapshot.queryParamMap.get('user') as any , 'name,id,email');

      let [submission, jobOrder, corporateUser] = await Promise.all([submissionPromise, jobOrderPromise,currentUserPromise]);

      submission = submission.data;
      jobOrder = jobOrder.data;
      this.submission = submission;
      this.jobOrder = jobOrder;
      this.fromUser = corporateUser.data;
      console.log('dsadsadsadadsad', submission, jobOrder);

      

        this.textControl = new TextBoxControl({ key: 'summary', label: 'Summary', readOnly: true, value: `Target for ${jobOrder.clientCorporation.name}`});
        this.jobOrderPickerControl = new PickerControl({
          key: 'jobOrder',
          multiple: true,
          label: 'Job Order',
          required: true,
          value: [{ searchEntity:'JobOrder', value: jobOrder.id, label: jobOrder.title, ...jobOrder }],
          readOnly: true,
          config: {
            format: '$label',
            previewTemplate: EntityPickerResult,
            resultsTemplate: EntityPickerResults,
            type: 'JobOrder',
            options: [{
              searchEntity:'JobOrder', 
              value: 'Apple',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'JobOrder', 
              value: 'Banana',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'JobOrder', 
              value: 'Grapes',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'JobOrder', 
              value: 'Orange',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'JobOrder',
              value: 'Pear',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }],
          },
        });
        this.candidatePickerControl = new PickerControl({
          key: 'candidates',
          multiple: true,
          label: 'Candidate',
          required: true,
          value: [{ searchEntity:'Candidate', value: submission.candidate.id, label: submission.candidate.name, ...submission.candidate }],
          readOnly: true,
          config: {
            format: '$label',
            previewTemplate: EntityPickerResult,
            resultsTemplate: EntityPickerResults,
            type: 'Candidate',
            options: [{
              searchEntity:'Candidate', 
              value: 'Apple',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'Candidate', 
              value: 'Banana',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'Candidate', 
              value: 'Grapes',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'Candidate', 
              value: 'Orange',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'Candidate',
              value: 'Pear',
              firstName: 'Charles',
              lastName: 'Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }],
          },
        });
        this.ownerPickerControl = new PickerControl({
          key: 'owner',
          multiple: true,
          label: 'Candidate Recruiter',
          required: true,
          value: [{ searchEntity:'User', value: submission.candidate.owner.id, label: submission.candidate.owner.name, ...submission.candidate.owner }],
          readOnly: true,
          config: {
            format: '$label',
            previewTemplate: EntityPickerResult,
            resultsTemplate: EntityPickerResults,
            type: 'User',
            options: [{
              searchEntity:'CorporateUser', 
              value: 'Apple',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'CorporateUser', 
              value: 'Banana',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, 
            {
              searchEntity:'CorporateUser', 
              value: 'Grapes',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'CorporateUser', 
              value: 'Orange',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }, {
              searchEntity:'CorporateUser',
              value: 'Pear',
              firstName: 'Charles',
              lastName: 'Barnes',
              name: 'Charles Barnes',
              label: 'Charles Barnes',
              companyName: 'Bullhorn',
              phone: '617-555-6789',
              address: { city: 'Boston', state: 'MA' },
              occupation: 'Developer',
              status: 'Active',
            }],
          },
        });
        this.commentsControl = new QuickNoteControl({ 
          key: 'comments', 
          label: 'Comments',
          config: {
            triggers: {
            },
            options: {
            },
            renderer: {
            },
          }
        });
        this.textForm = this.formUtils.toFormGroup([this.textControl, this.candidatePickerControl, this.ownerPickerControl, this.commentsControl, this.jobOrderPickerControl]);
  
      //this.dynamicForm = this.formUtils.toFormGroupFromFieldset(this.dynamic);
    } else {
      this.connected = false;
      this.loading = false;
    }
  } 

}